const WorkOrderHistoryMixin = {
    data() {
        return {
            woStatusRanks: [],
            allWoiWasteTypes : null,
            settingsHash : null,
        };
    },
    computed: {
        allServices() {
            return this.$store.getters.GET_SERVICES.list;
        },
        allWasteStreamCombos() {
            return this.$store.getters.GET_WASTE_COMBO_LIST.list;
        },
        allWasteStreams() {
            return this.$store.getters.GET_ALL_WASTE_STREAMS.list;
        },
        serviceWasteStreamHash() {
            var hash = [];

            if (this.allServices && this.allWasteStreams) {
                var services = this.allServices;
                var wasteStreams = this.allWasteStreams;
                var wasteStreamCombos = this.allWasteStreamCombos;

                for (let i = 0; i < services.length; i++) {
                    services[i].wasteStreams = [];
                    services[i].wasteStreamCombos = [];
                    for (let j = 0; j < wasteStreams.length; j++) {
                        if (
                            services[i].service_setting_id ==
                            wasteStreams[j].service_setting_id
                        ) {
                            services[i].wasteStreams.push(wasteStreams[j]);
                        }
                    }
                    for (let j = 0; j < wasteStreamCombos.length; j++) {
                        if (
                            services[i].service_setting_id ==
                            wasteStreamCombos[j].service_setting_id
                        ) {
                            services[i].wasteStreamCombos.push(
                                wasteStreamCombos[j]
                            );
                        }
                    }
                }

                var servicesHash = [];

                for (let i = 0; i < services.length; i++) {
                    var condensedService = {
                        service_setting_id: services[i].service_setting_id,
                        service_name: services[i].service_name,
                        api_value: services[i].api_value,

                        // Date Selection Values
                        date_selection: services[i].date_selection,
                        weekly_start_day: services[i].weekly_start_day,

                        wasteStreams: [],
                        wasteStreamCombos: []
                    };
                    services[i].wasteStreams.forEach(wasteStream => {
                        condensedService.wasteStreams.push({
                            waste_stream_setting_id:
                                wasteStream.waste_stream_setting_id,
                            waste_stream_name: wasteStream.waste_stream_name,
                            api_value: wasteStream.api_value,
                            is_hidden:
                                !wasteStream.is_cso && !wasteStream.is_res
                        });
                    });
                    services[i].wasteStreamCombos.forEach(wasteStreamCombo => {
                        var primary_waste_stream =
                            wasteStreamCombo.primary_waste_stream;
                        condensedService.wasteStreamCombos.push({
                            primary_waste_stream_setting_id:
                                primary_waste_stream.waste_stream_setting_id,
                            primary_waste_stream_name:
                                primary_waste_stream.waste_stream_name,
                            primary_waste_stream_api_value:
                                primary_waste_stream.api_value,
                            api_value: wasteStreamCombo.api_value
                        });
                    });

                    servicesHash.push(condensedService);
                }

                servicesHash = servicesHash.sort((a, b) => {
                    var textA = a.api_value.toUpperCase();
                    var textB = b.api_value.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                hash = servicesHash;
            }

            return hash;
        }
    },
    mounted() {
        this.$store.dispatch("getServices");
        this.$store.dispatch("getAllWasteStreams");
        this.$store.dispatch("getWasteComboList");
        this.$store.dispatch("getAllWoiWasteType").then(data => this.allWoiWasteTypes = data)
        this.$store.dispatch("getWoStatusRank").then(data => {
            // -- Format as array
            var list = data ? data.list : null;
            if (list && Array.isArray(list)) {
                list = list.sort((a, b) => a.rank - b.rank);
                this.woStatusRanks = list.map(statusRank => statusRank.status);
            }
        });
    },
    methods: {
        buildEntitlementUsageHash(addressEntitlementArr) {
            var hash = {};

            addressEntitlementArr.forEach(addressEntitlement => {
                var entitlementDetails =
                    addressEntitlement.entitlementDetails || [];
                entitlementDetails.forEach(entitlementDetail => {
                    hash[entitlementDetail.bookingReferenceNo.trim()] = {
                        ...entitlementDetail
                    };
                });
            });
            return hash;
        },
        buildWorkOrderNameHash(workOrders) {
            var hash = {}

            // --- Make a hash of the current settings
            if(!this.settingsHash){
                this.settingsHash = this.buildSettingsHash();
            }
            var settingList = []
            for (const settingId in this.settingsHash) {
                settingList.push(this.settingsHash[settingId])
            }

            // --- Group Work Orders by CRN
            workOrders.forEach(workOrder => {
                if(!hash[workOrder.CRN]){
                    hash[workOrder.CRN] = []
                }
                hash[workOrder.CRN].push({
                    serviceApi : workOrder.woServiceType,
                    woWasteType : workOrder.woWasteType,
                    woReferenceNo : workOrder.woReferenceNo,
                })
            });

            // --- Identify the setting hash that contains all of the streams in the work order
            for (const crn in hash) {
                var crnTransaction = hash[crn]

                var foundMatchingSetting = settingList.find(service => {
                    var missingWasteStreamExists = crnTransaction.some(wasteStream => {
                        if(wasteStream.serviceApi != service.serviceApi){
                            return true
                        }
                        else{
                            return !service.wasteStreams.some(serviceWasteStream => wasteStream.woWasteType == serviceWasteStream.streamApi)
                        }
                    })

                    return !missingWasteStreamExists
                })

                // --- If it exists, map the displaynames
                if(foundMatchingSetting){
                    hash[crn].forEach(wasteStream => {
                        var serviceWasteStream = foundMatchingSetting.wasteStreams.find(serviceWasteStream => wasteStream.woWasteType == serviceWasteStream.streamApi) || {}
                        wasteStream.displayName = serviceWasteStream.streamName
                    })
                }
            }

            return hash
        },
        buildSettingsHash(){
            var settingsHash = {}

            this.allServices.forEach(service => {
                settingsHash[service.service_setting_id] = {
                    serviceId : service.service_setting_id,
                    serviceName : service.service_name,
                    serviceApi : service.api_value,
                    wasteStreams : []
                }
            });
            this.allWasteStreams.forEach(wasteStream => {
                if(settingsHash[wasteStream.service_setting_id]){
                    settingsHash[wasteStream.service_setting_id].wasteStreams.push({
                        streamId : wasteStream.waste_stream_setting_id,
                        streamName : wasteStream.waste_stream_name,
                        streamApi : wasteStream.api_value,
                    })
                }
            })
            this.allWoiWasteTypes.forEach(woiWasteType=>{
                if(woiWasteType.waste_stream_setting){
                    var streamId = woiWasteType.waste_stream_setting.waste_stream_setting_id
                    for (const serviceId in settingsHash) {
                        var streamExistsInService = settingsHash[serviceId].wasteStreams.some(wasteStream => wasteStream.streamId == streamId);
                        if(streamExistsInService){
                            settingsHash[serviceId].wasteStreams.push({
                                streamId : "wwt-" + woiWasteType.woi_waste_type.woi_waste_type_id,
                                streamName : woiWasteType.woi_waste_type.woi_waste_name,
                                streamApi : woiWasteType.woi_waste_type.api_value,
                                isWoiWasteType : true
                            })
                        }
                    }
                }
            })

            return settingsHash
        }
    }
};

module.exports = WorkOrderHistoryMixin;
